import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { BaSeSmall1 } from '@base/react';

export const RelatorioFluxoMoneyCell = ({ value, type, isSub }) => {
  const money = Sebrae.useMask(parseFloat(value).toFixed(2), 'decimal');
  const color = React.useMemo(() => {
    if (money === '0,00') {
      return isSub ? '#617385' : '#243342';
    }
    if (type === 'auto') {
      return value > 0 ? '#008537' : '#B22400';
    }
    return type === 'Receita' ? '#008537' : '#B22400';
  }, [isSub, money, type, value]);

  return (
    <BaSeSmall1 color={color}>
      {/*type === 'Despesa' && money !== '0,00' && '-'*/}
      {`R$ ${money}`}
    </BaSeSmall1>
  );
};
